import { ValueTextPair } from "../models/value-text-pair";

export class RegisterConst {

  /** 自費掛號 */
  static readonly IType_0_SelfPay = '0';
  /** 插卡掛號 */
  static readonly IType_1_IC = '1';
  /** 異常掛號 */
  static readonly IType_2_Abnormal = '2';
  /** 欠卡掛號 */
  static readonly IType_3_OweCard = '3';
  /** 欠卡掛號(不可還卡) */
  static readonly IType_4_OweCardNoReturn = '4';

  /** 保險身分-自費 */
  static readonly ICode_000_SelfPay = '000';
  /** 保險身分-健保 */
  static readonly ICode_A_健保 = 'A';
  /** 保險身分-自費 */
  static readonly ICode_001_重傷病 = '001';
  /** 保險身分-職災 */
  static readonly ICode_006_職災 = '006';
  /** 保險身分-其他 */
  static readonly ICode_009_Other = '009';
  /** 保險身分-替代役 */
  static readonly ICode_906_替代役 = '906';

  /** 類別-一般看診 */
  static readonly SameTreat__一般看診 = '';
  /** 類別-洗腎 */
  static readonly SameTreat_0_洗腎 = '0';
  /** 類別-復健 */
  static readonly SameTreat_1_復健 = '1';
  /** 類別-預防保健 */
  static readonly SameTreat_2_預防保健 = '2';
  /** 類別-換藥 */
  static readonly SameTreat_3_換藥 = '3';
  /** 類別-月療 */
  static readonly SameTreat_4_月療 = '4';
  /** 類別-全療 */
  static readonly SameTreat_5_全療 = '5';
  /** 類別-內科同療 */
  static readonly SameTreat_6_內科同療 = '6';
  /** 類別-同日同醫 */
  static readonly SameTreat_7_同日同醫 = '7';
  /** 類別-慢箋領藥 */
  static readonly SameTreat_8_慢箋領藥 = '8';
  static readonly SameTreat_C_尿失禁治療 = 'C';
  static readonly SameTreat_F_在宅計畫 = 'F';
  /** 類別-牙科同療 */
  static readonly SameTreat_5_牙科同療 = '5';
  /** 類別-牙統療程 */
  static readonly SameTreat_6_牙統療程 = '6';
  /** 類別-牙科療程未定 */
  static readonly SameTreat_牙科療程未定 = '5,6';
  /** 支援雙療程之首療程 */
  static readonly SameTreat_支援雙療程之首療程: string[] = ['1', '3', '4'];

  /** 保險身分-其他 */
  static readonly INote_代檢 = '+7';
  //O有簽章 X簽章異常 P正常不需寫卡或補正 U 待診中  F 改自費  H退掛 D刪除病歷未退掛
  static readonly TPK2M_O有簽章 = 'O'
  static readonly TPK2M_X簽章異常 = 'X'
  static readonly TPK2M_P正常不需寫卡或補正 = 'P'
  static readonly TPK2M_U待診中 = 'U'
  static readonly TPK2M_F改自費 = 'F'
  static readonly TPK2M_H退掛 = 'H'
  static readonly TPK2M_D刪除病歷未退掛 = 'D'

  // 狀態碼: A一般候診、0就診中、D保留排後、R保留排前、E預約、F完診、G拿藥、H取消、*急診、C已掛號未付款
  // code definition: 對應server端的定義，兩邊是一樣的
  /** 就診中 */
  static readonly Code_Status_Examining = '0';
  /** 候診 */
  static readonly Code_Status_Waiting = 'A';
  /** 排1 */
  static readonly Code_Status_Queue1 = '1';
  /** 已掛號未付款(不可顯示候診) */
  static readonly Code_Status_RegNotPay = 'C';
  /** 保留排後 */
  static readonly Code_Status_ReservedLater = 'D';
  /** 預約 */
  static readonly Code_Status_Appointment = 'E';
  /** 預約報到 */
  static readonly Code_Status_AppointmentCheckIn = 'Z';
  /** 完診 */
  static readonly Code_Status_Finish = 'F';
  /** 拿藥 */
  static readonly Code_Status_PickUpDrug = 'G';
  /** 取消 */
  static readonly Code_Status_Cancel = 'H';
  /** 急診 */
  static readonly Code_Status_Emergency = '*';
  /** 複製 */
  static readonly Code_Status_Duplication = 'J';
  /** 保留(前) */
  static readonly Code_Status_ReservedFront = 'R';

  // 櫃台 候診清單 狀態預設選項 :
  static readonly StatusCodeList_ForDesk: string = '0,A,D,G,*,1,Z,R';
  // 醫師 候診清單 狀態預設選項 :
  static readonly StatusCodeList_ForDoctor: string = '0,A,D,*,1,Z';
  // 全部 候診清單 狀態預設選項 :
  static readonly StatusCodeList_All: string = '0,A,D,E,G,*,F,C,1,Z,R';
  // 門診登錄顯示的後續候診清單
  static readonly StatusCodeList_ForExamining: string = 'A,D,*,1,Z';
  static readonly StatusCodeList_Phar: string = 'A,F';
  // 掛號櫃台修改掛號時，可選擇那些狀態
  static readonly StatusCodeList_CanSelect: string[] = ['A', 'G', 'E', '*', 'H', 'J', 'Z', 'R'];
  static readonly StatusCodeList_CanSelectButCannotSelectH: string[] = ['A', 'G', 'E', '*', 'J', 'Z', 'R'];

  // 候診清單要顯示的人數統計
  static readonly StatusCodeList_Count: string = 'A,D,*,1,F,G,E,0';

  // payment status
  static readonly Code_Payment_Registered = '0'; // 已掛號未批價
  static readonly Code_Payment_Priced = '1'; // 已批價未付款
  static readonly Code_Payment_Paying = '2'; // 結帳中
  static readonly Code_Payment_Paid = '3'; // 已付款
  static readonly Code_Payment_Debt = '4'; // 賒欠
  static readonly Code_Payment_Refund = '5'; // 退費

  // signal
  static readonly SignalGroupName = 'register';

  // signal
  static readonly Mode_Reg = 'REG'; // 掛號櫃台清單模式
  static readonly Mode_Opd = 'OPD'; // 醫師門診清單模式
  static readonly Mode_Resv = 'RESV'; // 醫師門診預約選入模式
  static readonly Mode_Phar = 'PHAR'; // 藥局門診清單模式

  //卡序
  static readonly Icno_Smoking_Cessation = 'IC07';//戒菸
  static readonly Icno_Vaccine_Flu = 'AU';//流感疫苗
  static readonly Icno_Vaccine_Child = 'CU';//兒童常規疫苗
  static readonly Icno_Vaccine_Pneumococcal = 'DU';//肺炎鏈球菌多醣體疫苗
  static readonly Icno_Vaccine_Covid = 'VU';//Covid 疫苗

  static readonly Icno_Covid_Confirmed = 'HV';//COVID-19居家確診
  static readonly Icno_Metabolic_Syndrome = 'MT';//代謝症候群防治計畫
  static readonly Icno_Icno_Cancer_Tracking = 'C4';//癌症治療品質改善計畫
  static readonly Icno_PregnantWithoutNHIForHIVTest = 'B9';//無健保孕婦愛滋檢查
  static readonly Icno_WithoutNHIForHIVTest = 'B1';//無健保愛滋檢查
    static readonly Icno_NHIForHIVTest = '10';//健保愛滋檢查


  static readonly Isqno_VideoCall_Covid = 'HVIT';//疫情視訊看診
  static readonly Isqno_Metabolic_Syndrome = 'MSPT';//代謝症候群防治計畫之個案收案、追蹤及年度評估
  static readonly Isqno_Icno_Cancer_Tracking = 'ICC4';//癌症治療品質改善計畫

  static readonly Nhictp_01_Normal = '01';//一般西醫
  static readonly Nhictp_AD_職災 = 'AD';//職災就醫序號
  static readonly Nhictp_CA_其他不計就醫 = 'CA';//其他不計就醫
  static readonly Nhictp_AC_預防保健 = 'AC';//預防保健
  /** 有健保孕婦愛滋篩檢卡序清單（40~54，對應產檢週次，申報案類B9） */
  static readonly Icno_HIVScreenings = ['40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54'];

}

export class RegisterVaccineConst {
  /** Covid 疫苗 */
  static readonly Isqno_Vaccine_Covid = 'VU';
  /** 肺炎鏈球菌多醣體疫苗 */
  static readonly Isqno_Vaccine_Pneumococcal = 'DU';
  /** 流感疫苗 */
  static readonly Isqno_Vaccine_Flu = 'AU';
  /** 兒童常規疫苗 */
  static readonly Isqno_Vaccine_Child = 'CU';
  /** 疫苗集合for VU,DU,AU,CU */
  static readonly vaccineCodes: string[] = [
    RegisterVaccineConst.Isqno_Vaccine_Covid,
    RegisterVaccineConst.Isqno_Vaccine_Pneumococcal,
    RegisterVaccineConst.Isqno_Vaccine_Flu,
    RegisterVaccineConst.Isqno_Vaccine_Child
  ];
  static readonly vaccineIsqnos: ValueTextPair[] = [
    { text: '流感疫苗', value: RegisterVaccineConst.Isqno_Vaccine_Flu },
    { text: '兒童常規疫苗', value: RegisterVaccineConst.Isqno_Vaccine_Child },
    { text: '肺炎鏈球菌疫苗', value: RegisterVaccineConst.Isqno_Vaccine_Pneumococcal },
    { text: 'COVID-19疫苗', value: RegisterVaccineConst.Isqno_Vaccine_Covid }
  ];

  /** AU流感疫苗 醫令StdCode 集合*/
  static readonly VaccineRxStdCode_AU: string[] = [
    'J000151206', 'J000138206', 'K001036206', 'K001126206', 'K000939206',
    'J000113277', 'K001272206', 'K001277206', 'K001275206', 'J000157206',//2025/09/17加上
    'K001274206', 'K001293206'];//2026/8/20加上 #18235
  /** DU肺炎鏈球菌疫苗 醫令StdCode 集合*/
  static readonly VaccineRxStdCode_DU: string[] = ['K000906206', 'K000492206', 'K001268206', 'K001319206'];
  /** CU兒童常規疫苗 醫令StdCode 集合*/
  static readonly VaccineRxStdCode_CU: string[] = [
    'KC00452206', 'KC00452209', 'KC00452221', 'K000301206', 'K000301209', 'K000351206', 'K000351209', 'K000906206', 'X000153206', 'K000702206',
    'X000154206', 'X000155229', 'K000440206', 'X000157206', 'J000085216', 'K000364206', 'K000510206', 'K000450206', 'K000480206', 'K000456206',
    'K000456209', 'K000501206', 'K000501209', 'K000967206', 'K000981206', 'X000164206', 'X000165206'
  ];
  /** VU COVID-19疫苗 醫令StdCode 開頭*/
  static readonly VaccineRxStdCode_VU = 'COVID19';

  /** AU流感疫苗 處置醫令StdCode */
  static readonly VaccineType9_AU = 'A2001C';
  /** DU肺炎鏈球菌疫苗 處置醫令StdCode */
  static readonly VaccineType9_DU = 'A3001C';
  /** CU兒童常規疫苗 處置醫令StdCode */
  static readonly VaccineType9_CU = 'A2051C';
}
export enum SelfpayWay {
  SelfPay_OnlyReg = '1',
  SelfPay_RegAndRxOther = '2',
  SelfPay_OnlyOPD = '3',
}
export class RegisterDiscountConst {
  static readonly Discount_Smoking_Cessation = 'ICON9'; // 戒菸掛號費
  static readonly Discount_Vaccine_Flu = 'FLRF'; // 流感掛號費
  static readonly Discount_Vaccine_Child = 'COKR'; // 一般兒童常規疫苗掛號費
  static readonly Discount_Vaccine_Pneumococcal = 'OMLR'; // 65歲以上肺炎鏈球菌疫苗掛號費
  static readonly Discount_Vaccine_Covid = 'CO19'; // COVID-19疫苗掛號費
}
/** 中醫相關 */
export class RegisterChineseConst {
  /** 不分療程(不自動轉療程) */
  static readonly RegardlessTreatment: string[] = ['E13', 'E14', 'F69', 'F70', 'F73', 'F74', 'F77', 'F78', 'F81', 'F82'];
  /** 針灸(電針)合併高度複雜性傷科後續治療 */
  static readonly FollowUpTreatment: string[] = ['F71', 'F72', 'F75', 'F76', 'F79', 'F80', 'F83', 'F84'];
  /** 「全民健康保險中醫門診總額醫療資源不足地區改善方案」之巡迴醫療服務計畫及「全民健康保險中醫門診總額照護機構中醫醫療照護方案」 */
  static readonly MobileHealthCareAndMedicalCare: string[] = [...RegisterChineseConst.RegardlessTreatment, ...RegisterChineseConst.FollowUpTreatment];
}
